import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { builder, BuilderComponent } from '@builder.io/react';
import NotFound from './NotFound';

builder.init(process.env.REACT_APP_BUILDER_API_KEY);

function BuilderPage() {
  const [content, setContent] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    setLoaded(false);
    setContent(null);

    builder
      .get('page', {
        userAttributes: {
          urlPath: location.pathname,
        },
      })
      .toPromise()
      .then((data) => {
        if (cancelled) return;
        setContent(data ?? null);
      })
      .catch((err) => {
        // Builder returned no content / bad API key / network error.
        // Don't let it become an unhandled promise rejection.
        console.warn('Builder.io fetch failed for', location.pathname, err);
        if (cancelled) return;
        setContent(null);
      })
      .finally(() => {
        if (!cancelled) setLoaded(true);
      });

    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  if (!loaded) {
    return (
      <div>
        <h2>Loading...</h2>
      </div>
    );
  }

  if (!content) {
    return <NotFound />;
  }

  return <BuilderComponent model="page" content={content} />;
}

export default BuilderPage;
